import Lottie from 'lottie-web'

var $items = document.getElementsByClassName('lottie-animation');

[].forEach.call($items, item => {

	var params = item.dataset

	item.style.width = (params.size ? params.size : params.width)+'px'
	item.style.height = (params.size ? params.size : params.height)+'px'
	
	Lottie.loadAnimation({
	  container: item,
	  renderer: 'svg',
	  loop: params.loop ? params.loop : true,
	  autoplay: params.autoplay ? params.autoplay : true,
	  path: params.path ? params.path : '/front/js/animations/'+params.name+'.json' 
	});

})
